export const assistantSummaryCounts = [
  { field: "completed", label: "Completed" },
  { field: "skipped", label: "Skipped" },
  { field: "unfinished", label: "Unfinished" },
] as const;
